<script>
    export let status = '';
</script>

<div>
    <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <p class="message">{status}</p>
</div>

<style>
    .message {
        font-size: 1.5em;
    }
</style>
